export const iconFontAwesomeArrowsRotateRight = (
	<i className="fa-solid fa-rotate-right"></i>
);
